export default __webpack_public_path__ + "static/trailer2-37023cd8b486d99420902e2759fa466c.mp4";